'use strict'

document.addEventListener('DOMContentLoaded', () => {
  /********************************
   * Vars
   *******************************/
  const html = document.querySelector('html');
  const body = document.querySelector('body');

  /********************************
   * Tabs
   *******************************/
  const pageIngredients = document.querySelector('.page-ingredients');

  if (pageIngredients) {
    const ingredientListWrap = pageIngredients.querySelector('.ingredient-list-wrap');
    const drawerIngredientsSlider = pageIngredients.querySelector('.drawer-slider');

    const mainTabsNav = pageIngredients.querySelector('#main-tabs-nav');
    const mainTabButtons = mainTabsNav.querySelectorAll('.tab-btn');

    let mainTabContentActive = pageIngredients.querySelector('.main-tab-content-item.active');
    const mainTabContentItem = pageIngredients.querySelectorAll('.main-tab-content-item');
    let subTabsNav = mainTabContentActive.querySelector('.sub-tabs-nav');
    let subTabButtons = subTabsNav.querySelectorAll('.tab-btn');
    let subTabsButtonActive = subTabsNav.querySelector('.tab-btn.active');
    let subTabContentItem = mainTabContentActive.querySelectorAll('.sub-tab-content-item');



    const hideIngredientsDrawer = () => {
      const buttonHideDrawer = pageIngredients.querySelectorAll('.button-drawer-close');
      const overflowHideDrawer = pageIngredients.querySelectorAll('.overflow');

      overflowHideDrawer.forEach(overflow => {
        overflow.addEventListener('click', () => {
          body.classList.remove('show-ingredients-drawer');
          overflow.closest('.ingredient-drawer').classList.remove('show-ingredients-drawer');
        })
      });

      buttonHideDrawer.forEach(button => {
        button.addEventListener('click', () => {
          body.classList.remove('show-ingredients-drawer');
          button.closest('.ingredient-drawer').classList.remove('show-ingredients-drawer');
        })
      });
    }

    const createIngredientsSlider = (sliderItems, sliderInit = 0) => {
      const drawerSliderInit = drawerIngredientsSlider.querySelector('.ingredient-slider_init');
      const sliderItemsWrap = drawerSliderInit.querySelector('.swiper-wrapper');

      new Swiper(drawerSliderInit).destroy();
      sliderItemsWrap.innerHTML = '';

      sliderItems.forEach(slide => {
        if (slide.classList.contains('show')) {
          const clonedSlide = slide.cloneNode(true);
          clonedSlide.classList.add('swiper-slide');
          sliderItemsWrap.append(clonedSlide);
        }
      });

      if (sliderItems.length > 1) {
        new Swiper(drawerSliderInit, {
          initialSlide: sliderInit,
          slidesPerView: 1,
          spaceBetween: 60,
          autoHeight: true,
          effect: "fade",
          speed: 1300,
          navigation: {
            nextEl: ".btn-next",
            prevEl: ".btn-prev",
          },
          pagination: {
            type: "fraction",
            el: ".swiper-pagination",
          },
        });
      }

      body.classList.add('show-ingredients-drawer');
      drawerIngredientsSlider.classList.add('show-ingredients-drawer');
    }

    const showSubContent = (button) => {
      let sliderIndex = 0;
      const dataTag = button.innerHTML.trim().toLowerCase().replace(/&amp;/g, "&");
      subTabContentItem.forEach(item => item.classList.remove('show'));

      subTabContentItem.forEach(tabItem => {
        const getItemTags = tabItem.getAttribute('data-tags');
        const tagsArray = getItemTags.split("&&").map(tag => tag.trim().toLowerCase());

        if (tagsArray.includes(dataTag)) {
          tabItem.classList.add('show');
          tabItem.setAttribute('data-slide-index', sliderIndex);
          sliderIndex++;
        }
      });
    }

    const onSubButtonsNav = (subButtonsNav) => {
      subButtonsNav.addEventListener('click', ({target}) => {
        if (target.classList.contains('tab-btn')) {
          subTabButtons.forEach(itemContent => itemContent.classList.remove('active'));
          subTabsButtonActive = target;
          target.classList.add('active');

          showSubContent(subTabsButtonActive);
        }
      });
    }

    const tabs = (tabsButtonsGroup, tabsButtons, tabsContentItems) => {
      tabsButtonsGroup.addEventListener('click', ({target}) => {
        if (target.classList.contains('tab-btn') && !target.classList.contains('active')) {

          tabsButtons.forEach(item => item.classList.remove('active'));
          target.classList.add('active');

          tabsContentItems.forEach(item => {
            item.getAttribute('data-tab') === target.getAttribute('data-tab')
                ? item.classList.add('active')
                : item.classList.remove('active')
          });

          mainTabContentActive = pageIngredients.querySelector('.main-tab-content-item.active');
          subTabsNav = mainTabContentActive.querySelector('.sub-tabs-nav');
          subTabButtons = subTabsNav.querySelectorAll('.tab-btn');
          subTabsButtonActive = subTabsNav.querySelector('.tab-btn.active');
          subTabContentItem = mainTabContentActive.querySelectorAll('.sub-tab-content-item');

          onSubButtonsNav(subTabsNav);
          showSubContent(subTabsButtonActive);
        }
      });
    }

    ingredientListWrap.addEventListener('click', ({target}) => {
      if (target.closest('.sub-tab-content-item')) {
        const sliderStart = target.closest('.sub-tab-content-item').getAttribute('data-slide-index');
        createIngredientsSlider(subTabContentItem, sliderStart);
      }
    });

    onSubButtonsNav(subTabsNav);
    showSubContent(subTabsButtonActive);
    tabs(mainTabsNav, mainTabButtons, mainTabContentItem);
    hideIngredientsDrawer();

    const ingredientsTabsBottom = pageIngredients.querySelectorAll('.ingredients-tabs-bottom');

    if (ingredientsTabsBottom.length) {
      ingredientsTabsBottom.forEach(lessIngredients => {
        const triggerDrawer = lessIngredients.querySelector('.btn-trigger-drawer');

        if (triggerDrawer) {
          const lessIngredientDrawer = lessIngredients.querySelector('.ingredient-drawer');

          triggerDrawer.addEventListener('click', () => {
            body.classList.add('show-ingredients-drawer');
            lessIngredientDrawer.classList.add('show-ingredients-drawer');
          });
        }
      });
    }
  }
});